<template>
  <div
    class="modal fade"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit" ref="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">สร้างโปรไฟล์ตัวแทนฯ</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label-required">ตัวแทนจำหน่าย:</label>
                      <select
                        id="agentCode"
                        name="agentCode"
                        ref="agentCode"
                        class="form-control m-select2"
                        style="width: 100%;"
                      ></select>
                      <span class="form-text"></span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    ระบบจะสร้างโปรไฟล์ตัวแทนฯให้ทั้งหมด 2 รายการ ดังนี้
                    <br />1) ชื่อตัวแทนฯ (ผู้ดูแลระบบ) <br />2) ชื่อตัวแทนฯ
                    (พนักงาน)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> สร้างโปรไฟล์
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      let self = this;
      if (
        !$(self.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/CompanyProfile/CreateDefault", {
          agentCode: $(self.$refs.agentCode).val(),
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $(self.$el).modal("hide");
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  mounted() {
    let self = this;

    $(self.$refs.form).validate({
      rules: {
        agentCode: "required",
      },
      messages: {
        agentCode: "กรุณาเลือกตัวแทนจำหน่าย",
      },
    });

    $(self.$el).on("hidden.bs.modal", function() {
      $('body').addClass('modal-open');
      $(self.$refs.agentCode)
        .val("")
        .trigger("change");
    });

    $(self.$refs.agentCode).select2({
      placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      allowClear: true,
      ajax: {
        url: "/Api/Agents/Select2SearchAgentName",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
          };
          return JSON.stringify(query);
        },
        processResults: function(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more,
            },
          };
        },
        transport: function(params, success, failure) {
          params.beforeSend = function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        },
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/User/AgentProfileCreateForm.vue